import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";

const Accordion = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const accordionItems = [
        {
            title: "Kleeo è davvero sicura per il mio gatto?",
            content: "Assolutamente sì. A differenza delle comuni lettiere rotanti, Kleeo utilizza l'esclusivo design Safe-Dome a corpo fisso: la struttura esterna rimane immobile, eliminando ogni rischio di schiacciamento. Inoltre, sensori a infrarossi e celle di carico bloccano istantaneamente ogni movimento se il gatto si avvicina durante il ciclo."
        },
        {
            title: "Come riesce a eliminare completamente gli odori?",
            content: "Kleeo combina due tecnologie: un cassetto rifiuti da 9 litri con chiusura ermetica e un sistema di purificazione ionica a pressione negativa. Questo processo neutralizza le molecole odorigene alla fonte, garantendo una casa sempre fresca anche dopo diversi giorni di utilizzo."
        },
        {
            title: "Che tipo di sabbia devo utilizzare?",
            content: "Per un funzionamento ottimale e per non affaticare il motore, consigliamo sabbia di bentonite minerale di alta qualità con buona capacità agglomerante. La granulometria selezionata permette al setaccio interno di separare i rifiuti in modo preciso, riducendo gli sprechi di sabbia pulita."
        },
        {
            title: "Ogni quanto devo svuotare il cassetto dei rifiuti?",
            content: "Grazie alla capacità extra-large di 9 litri, un singolo gatto può utilizzare Kleeo fino a 15 giorni prima che sia necessario svuotare il cassetto. Riceverai comunque una notifica in tempo reale sull'App Tuya quando il sacchetto è prossimo al riempimento."
        },
        {
            title: "È adatta a gatti di grandi dimensioni?",
            content: "Sì, il vano interno ha un volume di ben 65 litri, progettato per ospitare comodamente gatti da 1 a 10 kg. L'ingresso è stato studiato con un'altezza di soli 140 mm per facilitare l'accesso anche a gattini piccoli o gatti anziani con mobilità ridotta."
        }
    ];

    return (
        <div className="accordion" id="accordionExample">
            {accordionItems.map((item, index) => (
                <div className="accordion-item" key={index}>
                    <h3 className="accordion-header">
                        <button
                            className={`accordion-button ${activeIndex === index ? "" : "collapsed"}`}
                            onClick={() => toggleAccordion(index)}
                        >
                            {item.title}
                        </button>
                    </h3>
                    <div className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`}>
                        <div className="accordion-body">
                            <p>{item.content}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Accordion;
